import { Trans } from 'react-i18next';
import { ModifierKeys } from 'styled-components-modifiers';

// Import hooks
import { useTooltipPosition } from './useTooltipPosition';

// Import styles
import { Wrapper, Text } from './styles';

// Import types
import type { TValues, TKey } from 'types/libraries/i18n';

type Props = {
	children: React.ReactElement;
	i18nKey: TKey;
	namespace?: string;
	modifiers?: ModifierKeys | undefined;
	values?: TValues;
};

export const Tooltip = ({ children, i18nKey, namespace, modifiers = 'primary', values }: Props) => {
	const { wrapperRef, textRef } = useTooltipPosition();

	return (
		<Wrapper ref={wrapperRef} modifiers={modifiers}>
			{children}
			<Text ref={textRef}>
				<Trans ns={namespace} i18nKey={i18nKey} values={values} />
			</Text>
		</Wrapper>
	);
};
